/**
 * @param {object} object
 */
export function instanceOfFormField(object) {
    return 'model' in object;
}
/**
 * @param {FormField} object
 */
export function instanceOfValueFormField(object) {
    return 'indexField' in object;
}
/**
 * @param {FormField} object
 */
export function instanceOfButtonFormField(object) {
    return 'buttonField' in object;
}
/**
 * @param {FormField} object
 */
export function instanceOfFormFieldSection(object) {
    return 'fields' in object;
}
